import React from "react";
import { motion } from "framer-motion";
import usePrefersReducedMotion from "../../hooks/usePrefersReducedMotion";

/**
 * Cinematic reveal: soft fade + slide. Images use a gentle scale settle.
 * Reduced motion -> opacity only.
 */
export default function Reveal({
  children,
  as = "div",
  delay = 0,
  y = 26,
  variant = "text",
  className = "",
  amount = 0.2,
  ...rest
}) {
  const reduced = usePrefersReducedMotion();
  const MotionTag = motion[as] || motion.div;

  if (reduced) {
    return (
      <MotionTag
        className={className}
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true, amount: 0.05 }}
        transition={{ duration: 0.3 }}
        {...rest}
      >
        {children}
      </MotionTag>
    );
  }

  const initial = variant === "image" ? { opacity: 0, scale: 1.03, y: 18 } : { opacity: 0, y };
  const inView = variant === "image" ? { opacity: 1, scale: 1, y: 0 } : { opacity: 1, y: 0 };

  return (
    <MotionTag
      className={className}
      initial={initial}
      whileInView={inView}
      viewport={{ once: true, amount }}
      transition={{
        duration: variant === "image" ? 0.9 : 0.72,
        delay,
        ease: [0.16, 1, 0.3, 1],
      }}
      {...rest}
    >
      {children}
    </MotionTag>
  );
}
